export default __webpack_public_path__ + "static/media/SWT1300.34I-36804_-21711_0.cc1f44fe.jpg";